export default "__VITE_ASSET__CAAah3N3__"